document.addEventListener('DOMContentLoaded', () => {

  const menuItems = document.querySelectorAll('.js-hover-image-item');
  const menuHoverContainer = document.querySelector('.js-hover-image-container');

  if (menuItems && menuHoverContainer) {
    menuItems.forEach(menuItem => {

      const image = menuItem.dataset.hover;
      const id = menuItem.dataset.id;

      if (image) {

        menuItem.addEventListener('mouseover', () => {
          let item = menuHoverContainer.querySelector(`#image-${id}`);
          if (item) {
            item.style.display = 'block';
          } else {
            const elem = document.createElement('img');
            elem.setAttribute('src', image);
            elem.setAttribute('id', `image-${id}`);
            elem.setAttribute('class', 'mt-3 mt-lg-1 sf_rounded');
            elem.setAttribute(
              'style',
              'height: 215px; width: 570px; display: block; object-fit: cover; object-position: center;'
            );
            elem.setAttribute('height', '215');
            elem.setAttribute('width', '570');
            menuHoverContainer.appendChild(elem);
          }
        });

        menuItem.addEventListener('mouseleave', () => {
          const item = menuHoverContainer.querySelector(`#image-${id}`);
          if (item) {
            item.style.display = 'none';
          }
        });

      }

    });
  }

});



// WEBPACK FOOTER //
// ./src/scripts/modules/hoverImage.js